import { useTracking } from '@repo/tracking/use-tracking';
import { Trans, useTranslation } from '@repo/translations/use-translation';

import { useCartContext } from '@zooplus/cart-provider';

import { useAddMembershipToCart } from '../../../hooks/useCart';
import { MembershipOffer } from '../../../hooks/useMembershipOffer';
import { scrollToElement } from '../../../hooks/useScrollTo';
import { OfferPrice } from '../../UI/OfferPrice';
import { PremiumBanner } from '../../UI/PremiumBanner/PremiumBanner';
import { PROGRAM_PLANS_ANCHOR_ID } from '../program-plan/ProgramPlan/ProgramPlan';

import styles from './PremiumBannerLandingPage.module.css';

export interface PremiumBannerLandingPageProps {
  offer: MembershipOffer;
}

export const PremiumBannerLandingPage = ({ offer }: PremiumBannerLandingPageProps) => {
  const { t } = useTranslation();
  const { addMembershipToCart } = useAddMembershipToCart();
  const { trackClick } = useTracking();
  const { sid } = useCartContext();

  return (
    <div className={styles.premiumBannerLandingPage}>
      <PremiumBanner
        title={t('loyalty-program.public-landing-page.premium-banner.title')}
        subtitle={
          <Trans
            i18nKey={'loyalty-program.public-landing-page.premium-banner.subtitle'}
            components={{
              Price: (
                <OfferPrice
                  price={offer.price}
                  referencePrice={offer.referencePrice}
                  secondaryCurrencyPrice={offer.secondaryCurrencyPrice}
                />
              ),
            }}
          />
        }
        primaryButtonText={t(
          'loyalty-program.public-landing-page.premium-banner.primary-button-text',
        )}
        onPrimaryButtonClick={async () => {
          trackClick({
            sid,
            target: {
              name: 'premium_banner',
              id: 'add_membership_to_cart',
            },
          });
          await addMembershipToCart(offer.articleId);
        }}
        secondaryButtonText={t(
          'loyalty-program.public-landing-page.premium-banner.secondary-button-text',
        )}
        onSecondaryButtonClick={() => {
          scrollToElement(document.getElementById(PROGRAM_PLANS_ANCHOR_ID));
          trackClick({
            sid,
            target: {
              name: 'premium_banner',
              id: 'view_benefits_button',
            },
          });
        }}
      />
    </div>
  );
};
